export default "__VITE_ASSET__BDyJatE3__"